import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setOffset, setInnerWidth, setOuterWidth } from 'redux/modules/navbarTabs';
import Measure from 'react-measure';
import { Tab } from 'components';
import { HorizontalNav } from 'containers';
import * as styles from './TabPanel.scss';
var TabPanel = (_dec = connect(function (state) {
  return {
    innerWidth: state.navbarTabs.innerWidth,
    offset: state.navbarTabs.offset,
    organization: state.organization.current,
    outerWidth: state.navbarTabs.outerWidth,
    theme: state.theme
  };
}, {
  setOffset: setOffset,
  setInnerWidth: setInnerWidth,
  setOuterWidth: setOuterWidth
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(TabPanel, _Component);

  var _super = _createSuper(TabPanel);

  function TabPanel() {
    var _this;

    _classCallCheck(this, TabPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleLeftNav", function () {
      var _this$props = _this.props,
          offset = _this$props.offset,
          outerWidth = _this$props.outerWidth;
      var newOffset = Math.max(0, offset - outerWidth / 2);

      _this.props.setOffset(newOffset);
    });

    _defineProperty(_assertThisInitialized(_this), "handleRightNav", function () {
      var _this$props2 = _this.props,
          offset = _this$props2.offset,
          innerWidth = _this$props2.innerWidth,
          outerWidth = _this$props2.outerWidth;
      var maxLeft = innerWidth - outerWidth;
      var newOffset = Math.min(maxLeft, offset + outerWidth / 2);

      _this.props.setOffset(newOffset);
    });

    return _this;
  }

  _createClass(TabPanel, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          innerWidth = _this$props3.innerWidth,
          outerWidth = _this$props3.outerWidth; // If a new tab has been added it will be at the end, so scroll to the max offset

      if (this.props.tabData.length > prevProps.tabData.length && innerWidth > outerWidth) {
        var maxLeft = innerWidth - outerWidth;
        this.props.setOffset(maxLeft + 170);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          innerWidth = _this$props4.innerWidth,
          outerWidth = _this$props4.outerWidth,
          offset = _this$props4.offset,
          tabData = _this$props4.tabData;
      var tabs = tabData.map(function (tab, index) {
        return /*#__PURE__*/React.createElement(Tab, {
          title: tab.title,
          link: tab.link,
          active: tab.active,
          onClose: _this2.props.onTabClose,
          tabId: tab.id,
          key: tab.id
        });
      });
      var showLeftNav = this.props.offset > 0;
      var showRightNav = this.props.innerWidth > 0 && this.props.innerWidth - this.props.offset - 1 > this.props.outerWidth;
      return /*#__PURE__*/React.createElement(Measure, {
        onMeasure: function onMeasure(_ref) {
          var height = _ref.height,
              width = _ref.width;

          _this2.props.setOuterWidth(width);
        },
        whitelist: ['left', 'width'],
        useClone: true
      }, /*#__PURE__*/React.createElement(HorizontalNav, {
        className: styles.tabscroll,
        leftNavClass: "".concat(styles.leftNav, " ").concat(styles.button),
        rightNavClass: "".concat(styles.rightNav, " ").concat(styles.button),
        left: "0px",
        showLeftNav: showLeftNav,
        showRightNav: showRightNav,
        onRightNav: this.handleRightNav,
        onLeftNav: this.handleLeftNav,
        style: {
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(Measure, {
        onMeasure: function onMeasure(_ref2) {
          var width = _ref2.width;

          _this2.props.setInnerWidth(width);
        },
        whitelist: ['left', 'width'],
        useClone: true
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.innerTabWrap,
        style: {
          left: "-".concat(offset, "px")
        }
      }, tabs))));
    }
  }]);

  return TabPanel;
}(Component), _defineProperty(_class2, "contextTypes", {
  router: PropTypes.object.isRequired
}), _defineProperty(_class2, "defaultProps", {
  offset: 0,
  innerWidth: 0,
  outerWidth: 0
}), _defineProperty(_class2, "propTypes", {
  tabData: PropTypes.array.isRequired,
  onTabClose: PropTypes.func,
  setOffset: PropTypes.func.isRequired,
  offset: PropTypes.number.isRequired,
  outerWidth: PropTypes.number.isRequired,
  innerWidth: PropTypes.number.isRequired
}), _temp)) || _class);
export { TabPanel as default };